import React, { useState } from "react";
import GlobalDialog from "../../../../../../components/mui/Dialogue/GlobalDialog";
import { Autocomplete, Box, Button, TextField } from "@mui/material";
import { Icon } from "@iconify/react";
import { useSelector, useDispatch } from "react-redux";
import {
  CancelButton,
  UpdateButton,
} from "../../../../../../components/mui/Buttons/Buttons";
import { useSnackbar } from "notistack";
import { tagKra } from "../../../../../../redux/features/appraisalSlice";

const TagWill = ({ userId, update }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedWill, setSelectedWill] = useState([]);
  const { kralibraries, loading } = useSelector((state) => state.appraisal);

  const [masterDatas, setMasterDatas] = useState([]);

  const handleChange = (event, value) => {
    setSelectedWill(value);

    const transformed = value.map((item) => ({
      masterId: item.appraisal_library_id,
      weightage: 100,
    }));

    setMasterDatas(transformed);
  };
  const handleAddWill = () => {
    const data = {
      userId: userId,
      masterDatas: masterDatas,
    };
    if (masterDatas.length === 0) {
      return enqueueSnackbar("Please select a will...!", {
        variant: "error",
      });
    }
    dispatch(tagKra(data)).then((res) => {
      if (res.payload.status === "failed") {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
      } else if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        update((prev) => !prev);
        setOpen(false);
        setMasterDatas([]);
        setSelectedWill([]);
      }
    });
  };
  return (
    <GlobalDialog
      title={"Tag Will"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <Button
          startIcon={<Icon icon="tabler:tag" width="24" height="24" />}
          onClick={() => setOpen(true)}
          size="small"
        >
          Tag Will
        </Button>
      }
      content={
        <>
          {open ? (
            <Box>
              <Autocomplete
                multiple
                options={kralibraries}
                getOptionLabel={(option) => option.appraisal_library_name}
                value={selectedWill}
                onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Will"
                    placeholder="Choose..."
                  />
                )}
              />
            </Box>
          ) : null}
        </>
      }
      actionButton={
        <>
          <CancelButton size={"small"} action={() => setOpen(false)}>
            Cancel
          </CancelButton>
          <UpdateButton
            disabled={loading}
            size={"small"}
            action={handleAddWill}
          >
            {loading ? "Please wait..." : "Update"}
          </UpdateButton>
        </>
      }
    />
  );
};

export default TagWill;
